import s from './MainPage.module.scss';
import { Header } from 'components/common/Header';
import { Footer } from 'components/common/Footer';
import { ContentContainer } from 'components/common/ContentContainer';
import { ReactComponent as WorldIcon } from 'images/icons/world.svg';
import { ReactComponent as ShieldIcon } from 'images/icons/shield.svg';
import { ReactComponent as GeoIcon } from 'images/icons/geo.svg';
import { ButtonRed } from 'components/common/Button/ButtonRed';
import title from 'images/image1.png';
import advantages from 'images/image2.png';
import { ReactComponent as Keys } from 'images/image3.svg';

const icons = {
	world: <WorldIcon />,
	shield: <ShieldIcon />,
	geo: <GeoIcon />,
	keys: <Keys />,
};

export const MainPage = () => {
	return (
		<div className={s.mainPage}>
			<main>
				<section className={s.titleSection}>
					<Header className={s.header} isAuth={false} />

					<div className={s.titleBlock}>
						<ContentContainer>
							<h1>единая точка входа в инфраструктуру вашей компании</h1>
						</ContentContainer>
					</div>

					<ContentContainer className={s.container}>
						<div className={s.textBlock}>
							<span>
								Подключите офисы, дата-центры и удалённых сотрудников к единой
								защищённой сети
							</span>
							{/* <span>без ограничений</span> */}
						</div>

						<div className={s.iconsBlock}>
							{/* <div>
								<FlashIcon />
								<span>Только рабочие сервисы</span>
							</div> */}
							<div>
								{icons.world}
								<span>Доступ из любого офиса или локации</span>
							</div>
							<div>
								{icons.shield}
								<span>Поддержка OpenVPN, L2TP и других протоколов</span>
							</div>
							<div>
								{icons.geo}
								<span>Гибкий выбор интернет-выхода по GEO</span>
							</div>
						</div>

						<ButtonRed className={s.btn} children={'Оставить заявку'} />
						<img src={title} className={s.img} alt='img' />
					</ContentContainer>
				</section>

				<section className={s.advantagesSection}>
					<div className={s.subtitleBlock}>
						<ContentContainer>
							<h3 className={s.subtitle}>почему выбирают нас?</h3>
						</ContentContainer>
					</div>

					<ContentContainer className={s.container}>
						<img src={advantages} alt='img' />

						<ul>
							<li>
								Объединение офисов и дата-центров в одну сеть
								{/* <span>
									OpenVPN, WireGuard, IKEv2 и другие – мы предлагаем решения для
									любого устройства.
								</span> */}
							</li>

							<li>
								Простой доступ сотрудников к внутренним ресурсам
								{/* <span>Выбирайте лучшее под свои задачи.</span> */}
							</li>

							<li>
								Настройка выходов в интернет по регионам
								{/* <span>
									Получите доступ к защищенным сетям и пользуйтесь интернетом на
									своих условиях.
								</span> */}
							</li>
						</ul>
					</ContentContainer>
				</section>

				<ContentContainer>
					<section className={s.instructionSection}>
						<h3 className={s.subtitle}>Как это работает?</h3>

						<div className={s.instructionSection__content}>
							<video controls width='250' height='150'>
								{/* {/* <source src="flower.webm" type="video/webm"> */}
								{/* <source src='flower.mp4' type='video/mp4' /> */}
							</video>

							<div>
								<div></div>

								<div>
									<span>Настройте точки подключения</span>
									<span>Выдайте доступ сотрудникам</span>
									<span>Управляйте сетью из единого интерфейса</span>
								</div>
							</div>
						</div>
					</section>
				</ContentContainer>

				<ContentContainer>
					<section className={s.testSection}>
						<div>
							<h3 className={s.subtitle}>пробный период</h3>

							<span>
								Оцените, как просто объединить инфраструктуру компании в единую
								сеть. Оставьте заявку на демонстрацию
							</span>

							<ButtonRed children={'Оставить заявку'} />
						</div>

						{icons.keys}
					</section>
				</ContentContainer>
			</main>

			<Footer />
		</div>
	);
};
